export const nhlPackTypes = [
  0, 1, 2, 3, 5, 6, 7, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
  24, 25, 26, 27, 28, 29, 30, 31,
]; //TODO update to soccer pack types
export const getNumber = (value) => Number(value) || 0;

export const RatingTypes = {
  Base: 0,
  Silver: 1,
  Gold: 2,
  AllStar: 3
};

export const getDivisionNameByLevel = (level) => {
  switch (level) {
    case 1:
      return "Minors";
    case 2:
      return "Rookie";
    case 3:
      return "Pro";
    case 4:
      return "Veteran";
    case 5:
      return "Dangle";
    case 6:
      return "Celly";
    case 7:
      return "Beauty";
    case 8:
      return "All-Star";
    case 9:
      return "Champion";
    case 10:
      return "Legendary";
    case 11:
      return "Stanley";
    case 12:
      return "NHL UF Cup";
    default:
      return "";
  }
}